export default __webpack_public_path__ + "static/xavier-clausse-e1645187363183-c125c4907b1586218cb1e968a645c8f6.jpeg";